export default __webpack_public_path__ + "static/media/intro2.8da81753.mp4";